import React, { useEffect, useState, useRef } from 'react';
import { Heart, Star, MessageCircle, Gift, Lock, Video, Flag, Play, VolumeX, Volume2, Maximize, Zap, Users, BarChart2, Trophy, X, Send, Smile, Diamond, Calendar, Crown, CheckCircle, Search, Mic, Paperclip, ImageIcon, Camera, ChevronRight, RefreshCw } from 'lucide-react';
import { ChatMessageSuggestions } from './ChatMessageSuggestions';
import { GenerationUpsellCTA } from './GenerationUpsellCTA';
import { AutoSuggestedMessages } from './AutoSuggestedMessages';
interface GroupChatSectionProps {
  setShowAngelFeed: (show: boolean) => void;
  setSelectedAngelId: (id: string | null) => void;
  onNavigate?: (section: string) => void;
}
export const GroupChatSection: React.FC<GroupChatSectionProps> = ({
  setShowAngelFeed,
  setSelectedAngelId,
  onNavigate
}) => {
  const [messageInput, setMessageInput] = useState('');
  const [showTipMenu, setShowTipMenu] = useState(true);
  const [showFullTipMenu, setShowFullTipMenu] = useState(false);
  const [activePoll, setActivePoll] = useState<{
    question: string;
    options: string[];
    votes: number[];
    timeLeft: number;
  } | null>({
    question: 'Should Sophia try on the leather outfit next?',
    options: ['Yes!', 'No, the lace one!'],
    votes: [24, 18],
    timeLeft: 30
  });
  const [missionProgress, setMissionProgress] = useState(2);
  const [missionTotal, setMissionTotal] = useState(3);
  const [tipGoal, setTipGoal] = useState({
    current: 180,
    target: 300,
    title: 'Striptease Show'
  });
  const [arModeActive, setArModeActive] = useState(false);
  const [toyActive, setToyActive] = useState(true);
  const [videoMuted, setVideoMuted] = useState(true);
  const [showPremiumAction, setShowPremiumAction] = useState(false);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [toyPulsing, setToyPulsing] = useState(false);
  const [goalComplete, setGoalComplete] = useState(false);
  const [showViewers, setShowViewers] = useState(true);
  const [viewerCount, setViewerCount] = useState(120);
  const [tokenBalance, setTokenBalance] = useState(250);
  const [showPrivateModal, setShowPrivateModal] = useState(false);
  const [layoutMode, setLayoutMode] = useState<'side-by-side' | 'video-top'>('video-top');
  const [isShapeShiftActive, setIsShapeShiftActive] = useState(false);
  const [shapeShiftPreset, setShapeShiftPreset] = useState('Default');
  // Define the current angel context for this group chat
  const currentAngelId = '1'; // Sophia's ID
  const currentAngelName = 'Sophia';
  const chatEndRef = useRef<HTMLDivElement>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const FALLBACK_AVATAR = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Crect width='40' height='40' fill='%23f3f4f6'/%3E%3Cpath d='M20 20C24.4183 20 28 16.4183 28 12C28 7.58172 24.4183 4 20 4C15.5817 4 12 7.58172 12 12C12 16.4183 15.5817 20 20 20ZM20 22C13.3726 22 8 27.3726 8 34H32C32 27.3726 26.6274 22 20 22Z' fill='%23d1d5db'/%3E%3C/svg%3E";
  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = FALLBACK_AVATAR;
  };
  // Chat messages with different user types
  const [messages, setMessages] = useState([{
    id: 1,
    type: 'system',
    content: "Welcome to Sophia's Room",
    timestamp: '2:30 PM'
  }, {
    id: 2,
    type: 'tip',
    username: 'LoverBoy',
    userType: 'high-roller',
    amount: 500,
    content: 'became King of the Room!',
    timestamp: '2:31 PM'
  }, {
    id: 3,
    type: 'message',
    username: 'Sophia',
    userType: 'angel',
    content: "Hey everyone! Thanks for joining my stream! Who's excited for tonight's show? 💕",
    timestamp: '2:34 PM',
    badges: ['host'],
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
  }, {
    id: 4,
    type: 'message',
    username: 'LoverBoy',
    userType: 'high-roller',
    content: "Can't wait to see what you have planned for us tonight! You look amazing as always 😍",
    timestamp: '2:35 PM',
    badges: ['king', 'vip'],
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png'
  }, {
    id: 5,
    type: 'message',
    username: 'Jake42',
    userType: 'tipper',
    content: 'I just got here, what did I miss?',
    timestamp: '2:36 PM',
    badges: ['fan'],
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png'
  }, {
    id: 6,
    type: 'message',
    username: 'You',
    userType: 'user',
    content: 'That outfit looks incredible on you Sophia!',
    timestamp: '2:37 PM',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png'
  }, {
    id: 7,
    type: 'tip',
    username: 'Jake42',
    userType: 'tipper',
    amount: 50,
    content: 'tipped',
    timestamp: '2:37 PM'
  }, {
    id: 8,
    type: 'message',
    username: 'Sophia',
    userType: 'angel',
    content: 'Thank you Jake for the tip! 😘 And thanks for the compliment on my outfit! I picked it just for you guys tonight...',
    timestamp: '2:38 PM',
    badges: ['host'],
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
  }, {
    id: 9,
    type: 'message',
    username: 'NewViewer',
    userType: 'lurker',
    content: 'First time here, this is awesome!',
    timestamp: '2:39 PM',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png'
  }, {
    id: 10,
    type: 'message',
    username: 'DiamondDan',
    userType: 'fan-club',
    content: "Sophia you always have the best streams! Can't wait for the show to begin 💎",
    timestamp: '2:40 PM',
    badges: ['fanclub', 'vip'],
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png'
  }, {
    id: 11,
    type: 'tip',
    username: 'DiamondDan',
    userType: 'fan-club',
    amount: 100,
    content: 'tipped for Spin Wheel',
    timestamp: '2:41 PM'
  }]);
  // Leaderboard data
  const leaderboard = [{
    username: 'LoverBoy',
    amount: 500,
    badges: ['king', 'vip']
  }, {
    username: 'DiamondDan',
    amount: 350,
    badges: ['fanclub', 'vip']
  }, {
    username: 'Jake42',
    amount: 200,
    badges: ['fan']
  }, {
    username: 'BigSpender',
    amount: 150,
    badges: ['vip']
  }, {
    username: 'NightRider',
    amount: 100,
    badges: []
  }];
  // Viewers list
  const viewers = [{
    username: 'LoverBoy',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png',
    badges: ['king', 'vip']
  }, {
    username: 'DiamondDan',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    badges: ['fanclub', 'vip']
  }, {
    username: 'Jake42',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    badges: ['fan']
  }, {
    username: 'Sophia',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png',
    badges: ['host']
  }, {
    username: 'NewViewer',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png',
    badges: []
  }, {
    username: 'You',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png',
    badges: []
  }];
  // Tip menu items
  const tipMenuItems = [{
    id: 1,
    name: 'Blow Kiss',
    price: 25,
    icon: '💋'
  }, {
    id: 2,
    name: 'Moan',
    price: 50,
    icon: '🔊'
  }, {
    id: 3,
    name: 'Spin Wheel',
    price: 100,
    icon: '🎰'
  }, {
    id: 4,
    name: 'POV Close-up',
    price: 150,
    icon: '📸',
    locked: true
  }, {
    id: 5,
    name: 'Flash',
    price: 75,
    icon: '👀',
    hidden: !showFullTipMenu
  }, {
    id: 6,
    name: 'Spanking',
    price: 120,
    icon: '👋',
    hidden: !showFullTipMenu
  }, {
    id: 7,
    name: 'Toy Vibrate (20s)',
    price: 200,
    icon: '📳',
    hidden: !showFullTipMenu
  }, {
    id: 8,
    name: 'Name Write',
    price: 500,
    icon: '✍️',
    hidden: !showFullTipMenu
  }];
  // Premium locked features
  const premiumFeatures = [{
    id: 1,
    name: 'Shower Cam',
    price: 100,
    icon: '🚿'
  }, {
    id: 2,
    name: 'Private Show',
    price: 500,
    icon: '🔒'
  }, {
    id: 3,
    name: 'Exclusive Content',
    price: 250,
    icon: '📸'
  }];
  // Effect for poll countdown
  useEffect(() => {
    if (activePoll) {
      const timer = setInterval(() => {
        setActivePoll(prev => prev ? {
          ...prev,
          timeLeft: prev.timeLeft - 1
        } : null);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [activePoll]);
  // End poll when time runs out
  useEffect(() => {
    if (activePoll && activePoll.timeLeft <= 0) {
      setTimeout(() => {
        setActivePoll(null);
      }, 3000);
    }
  }, [activePoll]);
  // Simulate new messages coming in
  useEffect(() => {
    const messageInterval = setInterval(() => {
      const newMessage = generateRandomMessage();
      setMessages(prev => [...prev, newMessage]);
      // Don't auto-scroll if user has scrolled up
      if (chatContainerRef.current) {
        const {
          scrollHeight,
          scrollTop,
          clientHeight
        } = chatContainerRef.current;
        const isScrolledToBottom = scrollHeight - scrollTop - clientHeight < 50;
        if (isScrolledToBottom) {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
        }
      }
    }, 12000);
    return () => clearInterval(messageInterval);
  }, []);
  // Generate random messages for simulation
  const generateRandomMessage = () => {
    const messageTypes = ['message', 'tip', 'message', 'message'];
    const userTypes = ['lurker', 'tipper', 'high-roller', 'fan-club'];
    const randomUsernames = ['HotStud69', 'SexyViewer', 'BigTipper', 'LuckyGuy', 'FunNight', 'JustWatching'];
    const randomMessages = ['You look amazing today! 😍', 'Can you blow a kiss? 💋', 'Turn around please', 'Loving the stream!', "You're so beautiful", 'Hello from France!', 'More please! 🔥', 'Can we see a close-up?'];
    const type = messageTypes[Math.floor(Math.random() * messageTypes.length)];
    const userType = userTypes[Math.floor(Math.random() * userTypes.length)];
    const username = randomUsernames[Math.floor(Math.random() * randomUsernames.length)];
    const now = new Date();
    const timestamp = `${now.getHours()}:${now.getMinutes().toString().padStart(2, '0')} PM`;
    if (type === 'tip') {
      const tipAmounts = [25, 50, 75, 100];
      const amount = tipAmounts[Math.floor(Math.random() * tipAmounts.length)];
      return {
        id: Date.now(),
        type: 'tip',
        username,
        userType,
        amount,
        content: 'tipped',
        timestamp
      };
    } else {
      const content = randomMessages[Math.floor(Math.random() * randomMessages.length)];
      const badges = userType === 'fan-club' ? ['fanclub'] : userType === 'high-roller' ? ['vip'] : [];
      return {
        id: Date.now(),
        type: 'message',
        username,
        userType,
        content,
        timestamp,
        badges: badges,
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png'
      };
    }
  };
  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleSendMessage = () => {
    if (!messageInput.trim()) return;
    const newMessage = {
      id: Date.now(),
      type: 'message',
      username: 'You',
      userType: 'user',
      content: messageInput,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      }),
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKJHSejmCauGrG6epCzaMk/image.png'
    };
    setMessages(prev => [...prev, newMessage]);
    setMessageInput('');
    // Increment mission progress for sending a message
    if (missionProgress < missionTotal) {
      setMissionProgress(prev => prev + 1);
    }
    // Scroll to bottom after sending a message
    setTimeout(scrollToBottom, 100);
    // Simulate angel response
    setTimeout(() => {
      const angelResponse = {
        id: Date.now() + 1,
        type: 'message',
        username: 'Sophia',
        userType: 'angel',
        content: 'Thanks for the message! Do you want to see something special? Check out the tip menu 💋',
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        }),
        badges: ['host'],
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
      };
      setMessages(prev => [...prev, angelResponse]);
      setTimeout(scrollToBottom, 100);
    }, 3000);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  const handleTipAction = (amount: number, itemName: string) => {
    // Check if user has enough tokens
    if (tokenBalance < amount) {
      // Show "not enough tokens" message
      setMessages(prev => [...prev, {
        id: Date.now(),
        type: 'system',
        content: 'Not enough tokens! Purchase more to continue.',
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      }]);
      return;
    }
    // Deduct tokens
    setTokenBalance(prev => prev - amount);
    // Add tip message to chat
    const newTip = {
      id: Date.now(),
      type: 'tip',
      username: 'You',
      userType: 'user',
      amount: amount,
      content: `tipped for ${itemName}`,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages(prev => [...prev, newTip]);
    // Update goal progress
    const newProgress = Math.min(tipGoal.current + amount, tipGoal.target);
    setTipGoal(prev => ({
      ...prev,
      current: newProgress
    }));
    // Check if goal is complete
    if (newProgress >= tipGoal.target && !goalComplete) {
      setGoalComplete(true);
      setTimeout(() => {
        setMessages(prev => [...prev, {
          id: Date.now() + 1,
          type: 'system',
          content: '🎉 GOAL REACHED! Striptease show starting soon!',
          timestamp: new Date().toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })
        }]);
      }, 1000);
    }
    // Show toy activation effect if applicable
    if (amount >= 50 && toyActive) {
      setToyPulsing(true);
      setTimeout(() => setToyPulsing(false), 3000);
    }
    // Simulate angel response to tip
    setTimeout(() => {
      const responses = [`Thank you so much for the ${amount} token tip! 😘`, `Mmm thank you! You're so generous! 💕`, `That's so sweet of you! Thank you for the ${amount} tokens! 💋`, `You're amazing! Thanks for the tip! 🔥`];
      const angelResponse = {
        id: Date.now() + 2,
        type: 'message',
        username: 'Sophia',
        userType: 'angel',
        content: responses[Math.floor(Math.random() * responses.length)],
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        }),
        badges: ['host'],
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
      };
      setMessages(prev => [...prev, angelResponse]);
    }, 2000);
  };
  const handleVotePoll = (optionIndex: number) => {
    if (!activePoll) return;
    setActivePoll(prev => {
      if (!prev) return null;
      const newVotes = [...prev.votes];
      newVotes[optionIndex] += 1;
      return {
        ...prev,
        votes: newVotes
      };
    });
    // Add voting message to chat
    const newVote = {
      id: Date.now(),
      type: 'system',
      content: `You voted for "${activePoll.options[optionIndex]}"`,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages(prev => [...prev, newVote]);
  };
  const getUsernameColor = (userType: string) => {
    switch (userType) {
      case 'angel':
        return 'text-pink-500 dark:text-pink-400';
      case 'high-roller':
        return 'text-purple-500 dark:text-purple-400';
      case 'fan-club':
        return 'text-green-500 dark:text-green-400';
      case 'tipper':
        return 'text-blue-500 dark:text-blue-400';
      case 'user':
        return 'text-gray-800 dark:text-gray-200';
      default:
        return 'text-gray-500 dark:text-gray-400';
      // lurker
    }
  };
  const getBadgeIcon = (badge: string) => {
    switch (badge) {
      case 'king':
        return <Crown size={12} className="text-yellow-500 dark:text-yellow-400" fill="currentColor" data-id="element-7961" />;
      case 'vip':
        return <Diamond size={12} className="text-pink-500 dark:text-pink-400" data-id="element-7962" />;
      case 'fanclub':
        return <Heart size={12} className="text-green-500 dark:text-green-400" fill="currentColor" data-id="element-7963" />;
      case 'fan':
        return <Star size={12} className="text-blue-500 dark:text-blue-400" data-id="element-7964" />;
      case 'host':
        return <CheckCircle size={12} className="text-pink-500 dark:text-pink-400" fill="currentColor" data-id="element-7965" />;
      default:
        return null;
    }
  };
  const handleSelectSuggestion = (suggestion: string) => {
    setMessageInput(suggestion);
  };
  const handleSendSuggestion = (suggestion: string) => {
    setMessageInput(suggestion);
    setTimeout(() => {
      handleSendMessage();
    }, 100);
  };
  const getRecentMessages = () => {
    return messages.filter(msg => msg.type === 'message' && msg.content).slice(-3).map(msg => ({
      content: msg.content,
      sender: msg.userType === 'angel' ? 'angel' : 'user'
    }));
  };
  return <div className="w-full max-w-7xl mx-auto bg-white dark:bg-gray-900 text-gray-800 dark:text-white" data-id="element-7966">
      <h2 className="text-xl font-bold mb-4" data-id="element-7967">Live Group Chat</h2>
      {/* Layout Toggle */}
      <div className="flex items-center justify-end mb-2 gap-2" data-id="element-7968">
        <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-7969">
          Layout:
        </span>
        <button className={`px-2 py-1 rounded text-xs ${layoutMode === 'side-by-side' ? 'bg-pink-600 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300'}`} onClick={() => setLayoutMode('side-by-side')} data-id="element-7970">
          Side by Side
        </button>
        <button className={`px-2 py-1 rounded text-xs ${layoutMode === 'video-top' ? 'bg-pink-600 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300'}`} onClick={() => setLayoutMode('video-top')} data-id="element-7971">
          Video Top
        </button>
      </div>
      <div className={`grid ${layoutMode === 'side-by-side' ? 'grid-cols-1 md:grid-cols-2 gap-4' : 'grid-cols-1 gap-4'}`} data-id="element-7972">
        {/* Live Video Section */}
        <div className={`${layoutMode === 'video-top' ? 'order-1' : 'order-1 md:order-2'}`} data-id="element-7973">
          <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden" data-id="element-7974">
            {/* Video Header */}
            <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between" data-id="element-7975">
              <div className="flex items-center gap-2" data-id="element-7976">
                <div className="relative" data-id="element-7977">
                  <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-7978">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png" alt="Sophia" className="w-full h-full object-cover" data-id="element-7979" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-red-500 border-2 border-white dark:border-gray-800" data-id="element-7980"></div>
                </div>
                <div data-id="element-7981">
                  <h3 className="font-medium flex items-center gap-1" data-id="element-7982">
                    <span className="text-yellow-500 dark:text-yellow-400 cursor-pointer hover:underline" onClick={() => {
                    if (setSelectedAngelId && setShowAngelFeed) {
                      setSelectedAngelId('1');
                      setShowAngelFeed(true);
                    }
                  }} data-id="element-7983">
                      Sophia
                    </span>{' '}
                    Chat Room
                    <CheckCircle size={14} className="text-pink-500 dark:text-pink-400" fill="currentColor" data-id="element-7984" />
                  </h3>
                  <div className="flex items-center gap-2" data-id="element-7985">
                    <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-7986">
                      <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-7987"></span>
                      <span data-id="element-7988">LIVE</span>
                    </div>
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-7989">
                      •
                    </span>
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-7990">
                      {viewerCount} watching
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-7991">
                <button className={`w-8 h-8 flex items-center justify-center rounded-full ${arModeActive ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'}`} onClick={() => setArModeActive(!arModeActive)} title="Immersive Mode" data-id="element-7992">
                  <Video size={16} data-id="element-7993" />
                </button>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400" onClick={() => setShowPrivateModal(true)} title="Go Private" data-id="element-7994">
                  <Lock size={16} data-id="element-7995" />
                </button>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400" data-id="element-7996">
                  <Flag size={16} data-id="element-7997" />
                </button>
              </div>
            </div>
            {/* Video Player */}
            <div className="relative" data-id="element-7998">
              {/* Main Video */}
              <div className="aspect-video bg-gray-100 dark:bg-gray-900 relative overflow-hidden" data-id="element-7999">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hVeSxxpDikr1zQUyWxYzJJ/image.png" alt="Live stream" className={`w-full h-full object-cover ${arModeActive ? 'opacity-90' : ''}`} data-id="element-8000" />
                {/* AR Mode Overlay */}
                {arModeActive && <div className="absolute inset-0 bg-gradient-to-r from-pink-900/20 to-purple-900/20 pointer-events-none" data-id="element-8001">
                    <div className="absolute top-4 left-4 px-2 py-1 bg-white/80 dark:bg-black/50 backdrop-blur-sm rounded-lg text-xs text-pink-500 dark:text-pink-400 flex items-center gap-1" data-id="element-8002">
                      <Video size={12} data-id="element-8003" />
                      <span data-id="element-8004">Immersive Mode Active</span>
                    </div>
                  </div>}
                {/* King of the Room */}
                <div className="absolute top-4 right-4 bg-white/80 dark:bg-black/50 backdrop-blur-sm rounded-lg px-3 py-1.5 flex items-center gap-2" data-id="element-8005">
                  <Crown size={16} className="text-yellow-500 dark:text-yellow-400" fill="currentColor" data-id="element-8006" />
                  <div data-id="element-8007">
                    <div className="text-xs text-yellow-500 dark:text-yellow-400 font-medium" data-id="element-8008">
                      King of the Room
                    </div>
                    <div className="text-xs text-gray-800 dark:text-gray-300" data-id="element-8009">
                      LoverBoy{' '}
                      <span className="text-pink-500 dark:text-pink-400" data-id="element-8010">
                        500 💎
                      </span>
                    </div>
                  </div>
                </div>
                {/* Toy Connected */}
                {toyActive && <div className={`absolute bottom-4 right-4 bg-white/80 dark:bg-black/50 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2 ${toyPulsing ? 'animate-pulse bg-pink-100/80 dark:bg-pink-900/30' : ''}`} data-id="element-8011">
                    <span className={`w-2 h-2 rounded-full ${toyPulsing ? 'bg-pink-500 dark:bg-pink-400' : 'bg-green-500 dark:bg-green-400'} animate-pulse`} data-id="element-8012"></span>
                    <span className="text-xs text-gray-800 dark:text-gray-300" data-id="element-8013">
                      {toyPulsing ? 'Toy Vibrating' : 'Toy Connected'}
                    </span>
                  </div>}
                {/* Floating hearts animation */}
                <div className="absolute inset-0 pointer-events-none" data-id="element-8014">
                  <div className="absolute bottom-1/4 left-1/4 text-xl animate-bounce opacity-70" data-id="element-8015">
                    ❤️
                  </div>
                  <div className="absolute top-1/3 right-1/3 text-xl animate-ping opacity-70" style={{
                  animationDuration: '3s'
                }} data-id="element-8016">
                    ❤️
                  </div>
                  <div className="absolute bottom-1/2 right-1/4 text-xl animate-bounce opacity-70" style={{
                  animationDuration: '2s'
                }} data-id="element-8017">
                    ❤️
                  </div>
                </div>
                {/* Video Controls Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent" data-id="element-8018">
                  <div className="flex items-center justify-between" data-id="element-8019">
                    <div className="flex items-center gap-3" data-id="element-8020">
                      <button className="w-8 h-8 flex items-center justify-center rounded-full bg-white/50 dark:bg-white/30 backdrop-blur-sm" data-id="element-8021">
                        <Play size={16} className="text-gray-800 dark:text-white" fill="currentColor" data-id="element-8022" />
                      </button>
                      <button className="w-8 h-8 flex items-center justify-center rounded-full bg-white/50 dark:bg-white/30 backdrop-blur-sm" onClick={() => setVideoMuted(!videoMuted)} data-id="element-8023">
                        {videoMuted ? <VolumeX size={16} className="text-gray-800 dark:text-white" data-id="element-8024" /> : <Volume2 size={16} className="text-gray-800 dark:text-white" data-id="element-8025" />}
                      </button>
                    </div>
                    <button className="w-8 h-8 flex items-center justify-center rounded-full bg-white/50 dark:bg-white/30 backdrop-blur-sm" data-id="element-8026">
                      <Maximize size={16} className="text-gray-800 dark:text-white" data-id="element-8027" />
                    </button>
                  </div>
                </div>
                {/* Toy Activation Animation */}
                {toyPulsing && <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-8028">
                    <div className="relative" data-id="element-8029">
                      <div className="absolute inset-0 rounded-full bg-pink-500/20 animate-ping" data-id="element-8030"></div>
                      <div className="absolute inset-0 rounded-full bg-pink-500/30 animate-pulse" data-id="element-8031"></div>
                      <div className="relative z-10 p-3 bg-white/80 dark:bg-black/50 backdrop-blur-sm rounded-lg text-sm text-pink-500 dark:text-pink-400 flex items-center gap-2" data-id="element-8032">
                        <Zap size={16} className="text-pink-500 dark:text-pink-400" data-id="element-8033" />
                        <span data-id="element-8034">Toy Activated - Level 3</span>
                      </div>
                    </div>
                  </div>}
              </div>
              {/* Tip Goal Bar */}
              <div className="px-4 py-3 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700" data-id="element-8035">
                <div className="flex items-center justify-between mb-1" data-id="element-8036">
                  <div className="text-sm font-medium flex items-center gap-1 text-gray-800 dark:text-white" data-id="element-8037">
                    <Star size={14} className="text-pink-500 dark:text-pink-400" data-id="element-8038" />
                    <span data-id="element-8039">Goal: {tipGoal.title}</span>
                  </div>
                  <div className="text-sm" data-id="element-8040">
                    <span className="text-pink-500 dark:text-pink-400 font-medium" data-id="element-8041">
                      {tipGoal.current}
                    </span>
                    <span className="text-gray-500 dark:text-gray-400" data-id="element-8042">
                      /{tipGoal.target} 💎
                    </span>
                  </div>
                </div>
                <div className="h-2.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-8043">
                  <div className={`h-full ${goalComplete ? 'animate-pulse' : ''} bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-500`} style={{
                  width: `${tipGoal.current / tipGoal.target * 100}%`
                }} data-id="element-8044"></div>
                </div>
              </div>
              {/* Tip Menu */}
              <div className="px-4 py-3 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700" data-id="element-8045">
                <div className="flex items-center justify-between mb-2" data-id="element-8046">
                  <h4 className="text-sm font-medium flex items-center gap-1 text-gray-800 dark:text-white" data-id="element-8047">
                    <Gift size={14} className="text-pink-500 dark:text-pink-400" data-id="element-8048" />
                    <span data-id="element-8049">Tip Menu</span>
                  </h4>
                  <button className="text-xs text-pink-500 dark:text-pink-400 hover:text-pink-600 dark:hover:text-pink-300" onClick={() => setShowFullTipMenu(!showFullTipMenu)} data-id="element-8050">
                    {showFullTipMenu ? 'Show Less' : 'Show All'}
                  </button>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-id="element-8051">
                  {tipMenuItems.filter(item => !item.hidden).map(item => <button key={item.id} className={`p-2 ${item.locked ? 'bg-gray-100/50 dark:bg-gray-700/50 relative overflow-hidden group' : 'bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600'} rounded-lg text-xs flex flex-col items-center justify-center transition-colors h-20 text-gray-800 dark:text-gray-200`} onClick={() => item.locked ? setShowPremiumAction(true) : handleTipAction(item.price, item.name)} data-id="element-8052">
                        {item.locked && <div className="absolute inset-0 bg-white/50 dark:bg-black/50 backdrop-blur-[1px] flex items-center justify-center group-hover:bg-white/40 dark:group-hover:bg-black/40 z-10" data-id="element-8053">
                            <Lock size={16} className="text-pink-500 dark:text-pink-400" data-id="element-8054" />
                          </div>}
                        <span className="text-xl mb-1" data-id="element-8055">{item.icon}</span>
                        <span className="font-medium" data-id="element-8056">{item.name}</span>
                        <span className="text-pink-500 dark:text-pink-400 mt-1" data-id="element-8057">
                          {item.price} 💎
                        </span>
                      </button>)}
                </div>
              </div>
              {/* Premium Action Popup */}
              {showPremiumAction && <div className="absolute inset-0 bg-white/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center z-10" data-id="element-8058">
                  <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 max-w-xs shadow-lg" data-id="element-8059">
                    <div className="flex items-center justify-between mb-3" data-id="element-8060">
                      <h4 className="font-medium flex items-center gap-1.5 text-gray-800 dark:text-white" data-id="element-8061">
                        <Lock size={16} className="text-pink-500 dark:text-pink-400" data-id="element-8062" />
                        <span data-id="element-8063">Premium Action</span>
                      </h4>
                      <button className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700" onClick={() => setShowPremiumAction(false)} data-id="element-8064">
                        <X size={14} className="text-gray-500 dark:text-gray-400" data-id="element-8065" />
                      </button>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-8066">
                      Unlock POV Close-up for 150 tokens. Sophia will bring the
                      camera up close for an intimate view.
                    </p>
                    <div className="flex gap-2" data-id="element-8067">
                      <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-300" onClick={() => setShowPremiumAction(false)} data-id="element-8068">
                        Cancel
                      </button>
                      <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-sm font-medium text-white" onClick={() => {
                    handleTipAction(150, 'POV Close-up');
                    setShowPremiumAction(false);
                  }} data-id="element-8069">
                        Unlock for 150 💎
                      </button>
                    </div>
                  </div>
                </div>}
              {/* Private Show Modal */}
              {showPrivateModal && <div className="absolute inset-0 bg-white/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center z-10" data-id="element-8070">
                  <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 max-w-xs shadow-lg" data-id="element-8071">
                    <div className="flex items-center justify-between mb-3" data-id="element-8072">
                      <h4 className="font-medium flex items-center gap-1.5 text-gray-800 dark:text-white" data-id="element-8073">
                        <Lock size={16} className="text-pink-500 dark:text-pink-400" data-id="element-8074" />
                        <span data-id="element-8075">Private Show</span>
                      </h4>
                      <button className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700" onClick={() => setShowPrivateModal(false)} data-id="element-8076">
                        <X size={14} className="text-gray-500 dark:text-gray-400" data-id="element-8077" />
                      </button>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-8078">
                      Start a private show with Sophia for 50 tokens per minute.
                      No one else will be able to see or hear you.
                    </p>
                    <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 mb-4" data-id="element-8079">
                      <div className="flex items-center justify-between mb-1" data-id="element-8080">
                        <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8081">
                          Price per minute
                        </span>
                        <span className="text-pink-500 dark:text-pink-400 font-medium" data-id="element-8082">
                          50 💎
                        </span>
                      </div>
                      <div className="flex items-center justify-between mb-1" data-id="element-8083">
                        <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8084">
                          Your balance
                        </span>
                        <span className="text-gray-800 dark:text-white font-medium" data-id="element-8085">
                          {tokenBalance} 💎
                        </span>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-8086">
                        <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8087">
                          Maximum time
                        </span>
                        <span className="text-gray-800 dark:text-white font-medium" data-id="element-8088">
                          {Math.floor(tokenBalance / 50)} minutes
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-2" data-id="element-8089">
                      <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-300" onClick={() => setShowPrivateModal(false)} data-id="element-8090">
                        Cancel
                      </button>
                      <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-sm font-medium text-white" onClick={() => {
                    setShowPrivateModal(false);
                    // Would initiate private show here
                  }} data-id="element-8091">
                        Start Private Show
                      </button>
                    </div>
                  </div>
                </div>}
              {/* Generation Upsell CTA - show with consistent flag instead of random chance */}
              <div className="my-4" data-id="element-8092">
                <GenerationUpsellCTA compact={true} onClose={() => {
                // Store a flag in state or localStorage to prevent showing again in this session
                localStorage.setItem('hideGroupGenerationUpsell', 'true');
              }} data-id="element-8093" />
              </div>
            </div>
            {/* Viewer Avatars */}
            {showViewers && <div className="px-4 py-2 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex items-center overflow-x-auto" data-id="element-8094">
                <div className="flex items-center gap-1 mr-3" data-id="element-8095">
                  <Users size={14} className="text-gray-500 dark:text-gray-400" data-id="element-8096" />
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8097">
                    {viewerCount} viewers
                  </span>
                </div>
                <div className="flex -space-x-2 overflow-hidden" data-id="element-8098">
                  {viewers.map((viewer, i) => <div key={i} className="w-6 h-6 rounded-full border border-white dark:border-gray-900 overflow-hidden group relative" title={viewer.username} data-id="element-8099">
                      <img src={viewer.avatar} alt={viewer.username} className="w-full h-full object-cover" data-id="element-8100" />
                      <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-white dark:bg-gray-800 rounded text-xs whitespace-nowrap shadow-lg border border-gray-200 dark:border-gray-700" data-id="element-8101">
                        <span className={getUsernameColor(viewer.badges.includes('host') ? 'angel' : viewer.badges.includes('king') ? 'high-roller' : viewer.badges.includes('fanclub') ? 'fan-club' : 'tipper')} data-id="element-8102">
                          {viewer.username}
                        </span>
                        {viewer.badges.map((badge, i) => <span key={i} className="ml-1" data-id="element-8103">
                            {getBadgeIcon(badge)}
                          </span>)}
                      </div>
                    </div>)}
                  <div className="w-6 h-6 rounded-full border border-white dark:border-gray-900 bg-gray-100 dark:bg-gray-700 flex items-center justify-center" data-id="element-8104">
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8105">
                      +{viewerCount - viewers.length}
                    </span>
                  </div>
                </div>
                <button className="ml-auto text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 flex items-center gap-1" onClick={() => setShowLeaderboard(!showLeaderboard)} data-id="element-8106">
                  <BarChart2 size={14} data-id="element-8107" />
                  <span data-id="element-8108">Leaderboard</span>
                </button>
              </div>}
            {/* Leaderboard Dropdown */}
            {showLeaderboard && <div className="px-4 py-3 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700" data-id="element-8109">
                <div className="flex items-center justify-between mb-2" data-id="element-8110">
                  <h4 className="text-sm font-medium flex items-center gap-1 text-gray-800 dark:text-white" data-id="element-8111">
                    <Trophy size={14} className="text-yellow-500 dark:text-yellow-400" data-id="element-8112" />
                    <span data-id="element-8113">Top Tippers</span>
                  </h4>
                  <button className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" onClick={() => setShowLeaderboard(false)} data-id="element-8114">
                    <X size={14} data-id="element-8115" />
                  </button>
                </div>
                <div className="space-y-2" data-id="element-8116">
                  {leaderboard.map((user, i) => <div key={i} className="flex items-center justify-between" data-id="element-8117">
                      <div className="flex items-center gap-2" data-id="element-8118">
                        <span className={`text-xs font-medium ${i === 0 ? 'text-yellow-500 dark:text-yellow-400' : i === 1 ? 'text-gray-400 dark:text-gray-300' : i === 2 ? 'text-amber-600 dark:text-amber-500' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-8119">
                          #{i + 1}
                        </span>
                        <span className={`text-sm ${getUsernameColor(user.badges.includes('king') ? 'high-roller' : user.badges.includes('fanclub') ? 'fan-club' : 'tipper')}`} data-id="element-8120">
                          {user.username}
                        </span>
                        {user.badges.map((badge, j) => <span key={j} data-id="element-8121">{getBadgeIcon(badge)}</span>)}
                      </div>
                      <span className="text-sm text-pink-500 dark:text-pink-400" data-id="element-8122">
                        {user.amount} 💎
                      </span>
                    </div>)}
                </div>
              </div>}
          </div>
        </div>
        {/* Chat Section */}
        <div className={`${layoutMode === 'video-top' ? 'order-2' : 'order-2 md:order-1'}`} data-id="element-8123">
          <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden flex flex-col h-[calc(100vh-150px)]" data-id="element-8124">
            {/* Chat Header */}
            <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between" data-id="element-8125">
              <div className="flex items-center gap-2" data-id="element-8126">
                <MessageCircle size={18} className="text-pink-500 dark:text-pink-400" data-id="element-8127" />
                <h3 className="font-medium text-gray-800 dark:text-white" data-id="element-8128">
                  Live Chat
                </h3>
              </div>
              <div className="flex items-center gap-2" data-id="element-8129">
                <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-700 rounded-lg px-2 py-1" data-id="element-8130">
                  <Diamond size={14} className="text-pink-500 dark:text-pink-400" data-id="element-8131" />
                  <span className="text-sm font-medium text-gray-800 dark:text-white" data-id="element-8132">
                    {tokenBalance}
                  </span>
                </div>
                <button className="px-2 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-xs font-medium text-white" title="Get More Tokens" onClick={() => {
                if (onNavigate) {
                  onNavigate('tokens');
                } else {
                  // Fallback if onNavigate isn't provided
                  const event = new CustomEvent('navigate', {
                    detail: {
                      section: 'tokens'
                    }
                  });
                  window.dispatchEvent(event);
                }
              }} data-id="element-8133">
                  Get More
                </button>
              </div>
            </div>
            {/* Daily Mission Banner */}
            <div className="p-2 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900" data-id="element-8134">
              <div className="rounded-lg bg-pink-50 dark:bg-pink-900/30 p-2 border border-pink-100 dark:border-pink-800/50" data-id="element-8135">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-8136">
                  <Calendar size={14} className="text-pink-500 dark:text-pink-400" data-id="element-8137" />
                  <h4 className="text-xs font-medium text-gray-800 dark:text-white" data-id="element-8138">
                    Daily Mission
                  </h4>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-300" data-id="element-8139">
                  Send {missionTotal} flirty messages to earn +5 XP
                </p>
                <div className="mt-1.5 flex items-center gap-2" data-id="element-8140">
                  <div className="flex-1 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-8141">
                    <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all" style={{
                    width: `${missionProgress / missionTotal * 100}%`
                  }} data-id="element-8142"></div>
                  </div>
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8143">
                    {missionProgress}/{missionTotal}
                  </span>
                </div>
              </div>
            </div>
            {/* Chat Messages */}
            <div ref={chatContainerRef} className="flex-grow overflow-y-auto p-3 space-y-3 bg-white dark:bg-gray-800" data-id="element-8144">
              {messages.map(message => {
              if (message.type === 'system') {
                return <div key={message.id} className="flex justify-center" data-id="element-8145">
                      <div className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-xs text-gray-600 dark:text-gray-300" data-id="element-8146">
                        {message.content}
                      </div>
                    </div>;
              }
              if (message.type === 'tip') {
                const isKing = message.content.includes('King');
                return <div key={message.id} className="flex justify-center" data-id="element-8147">
                      <div className={`px-3 py-1 ${isKing ? 'bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-100 dark:border-yellow-800/50' : 'bg-pink-50 dark:bg-pink-900/30 border border-pink-100 dark:border-pink-800/50'} rounded-lg text-xs`} data-id="element-8148">
                        <span className={getUsernameColor(message.userType)} data-id="element-8149">
                          {message.username}
                        </span>{' '}
                        {message.content}{' '}
                        <span className="text-pink-500 dark:text-pink-400" data-id="element-8150">
                          {message.amount} 💎
                        </span>
                      </div>
                    </div>;
              }
              // Regular message
              if (message.userType === 'user') {
                return <div key={message.id} className="flex items-start justify-end gap-2" data-id="element-8151">
                      <div className="max-w-[85%] bg-gradient-to-r from-pink-600 to-purple-600 rounded-t-xl rounded-bl-xl p-2.5 text-white" data-id="element-8152">
                        <p className="text-sm" data-id="element-8153">{message.content}</p>
                        <p className="text-xs text-gray-100 mt-1 text-right" data-id="element-8154">
                          {message.timestamp}
                        </p>
                      </div>
                      <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 flex-shrink-0" data-id="element-8155">
                        <img src={message.avatar} alt="You" className="w-full h-full object-cover" data-id="element-8156" />
                      </div>
                    </div>;
              }
              return <div key={message.id} className="flex items-start gap-2" data-id="element-8157">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-8158">
                      <img src={message.avatar} alt={message.username} className="w-full h-full object-cover" data-id="element-8159" />
                    </div>
                    <div className="max-w-[85%] bg-gray-100 dark:bg-gray-700 rounded-t-xl rounded-br-xl p-2.5" data-id="element-8160">
                      <div className="flex items-center gap-1 mb-1 flex-wrap" data-id="element-8161">
                        <span className={`text-xs font-medium ${getUsernameColor(message.userType)}`} data-id="element-8162">
                          {message.username}
                        </span>
                        {message.badges && message.badges.map((badge, i) => <span key={i} className="text-xs" data-id="element-8163">
                              {getBadgeIcon(badge)}
                            </span>)}
                      </div>
                      <p className="text-sm text-gray-800 dark:text-gray-200" data-id="element-8164">
                        {message.content}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-8165">
                        {message.timestamp}
                      </p>
                    </div>
                  </div>;
            })}
              {/* Poll */}
              {activePoll && <div className="bg-gray-50 dark:bg-gray-700 rounded-xl p-3 border border-gray-200 dark:border-gray-600" data-id="element-8166">
                  <div className="flex items-center gap-1.5 mb-2" data-id="element-8167">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-8168">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png" alt="Sophia" className="w-full h-full object-cover" data-id="element-8169" />
                    </div>
                    <div data-id="element-8170">
                      <span className="text-xs font-medium text-pink-500 dark:text-pink-400" data-id="element-8171">
                        Sophia
                      </span>
                      <span className="text-xs text-gray-500 dark:text-gray-400 ml-1" data-id="element-8172">
                        started a poll
                      </span>
                    </div>
                  </div>
                  <p className="text-sm font-medium mb-2 text-gray-800 dark:text-white" data-id="element-8173">
                    {activePoll.question}
                  </p>
                  <div className="space-y-2 mb-2" data-id="element-8174">
                    {activePoll.options.map((option, i) => {
                  const totalVotes = activePoll.votes.reduce((a, b) => a + b, 0);
                  const percentage = totalVotes > 0 ? Math.round(activePoll.votes[i] / totalVotes * 100) : 0;
                  return <button key={i} className="w-full relative overflow-hidden" onClick={() => handleVotePoll(i)} data-id="element-8175">
                          <div className="absolute left-0 top-0 bottom-0 bg-pink-100 dark:bg-pink-900/30 rounded-lg transition-all" style={{
                      width: `${percentage}%`
                    }} data-id="element-8176"></div>
                          <div className="relative p-2 flex items-center justify-between" data-id="element-8177">
                            <span className="text-sm text-gray-800 dark:text-gray-200" data-id="element-8178">
                              {option}
                            </span>
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-300" data-id="element-8179">
                              {percentage}%
                            </span>
                          </div>
                        </button>;
                })}
                  </div>
                  <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400" data-id="element-8180">
                    <span data-id="element-8181">
                      {activePoll.votes.reduce((a, b) => a + b, 0)} votes
                    </span>
                    <span data-id="element-8182">
                      {activePoll.timeLeft > 0 ? `${activePoll.timeLeft}s remaining` : 'Poll ended'}
                    </span>
                  </div>
                </div>}
              <div ref={chatEndRef} data-id="element-8183" />
            </div>
            {/* Chat Input */}
            <div className="p-3 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800" data-id="element-8184">
              {showSuggestions && <>
                  <div className="text-xs text-gray-500 dark:text-gray-400 mb-1.5 ml-1" data-id="element-8185">
                    Message suggestion tool (devil mode or angel mode)
                  </div>
                  <AutoSuggestedMessages onSendMessage={message => {
                setMessageInput(message);
                setTimeout(() => handleSendMessage(), 100);
              }} recentMessages={getRecentMessages()} angelName="Sophia" angelMood={['flirty', 'playful']} messageInput={messageInput} toyActive={toyActive} data-id="element-8186" />
                </>}
              <div className="flex items-center gap-2" data-id="element-8187">
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors" data-id="element-8188">
                  <Gift size={18} className="text-pink-500 dark:text-pink-400" data-id="element-8189" />
                </button>
                <div className="flex-1 bg-gray-100 dark:bg-gray-700 rounded-full px-4 py-2 flex items-center" data-id="element-8190">
                  <input type="text" placeholder="Type a message..." className="bg-transparent border-none outline-none w-full text-sm text-gray-800 dark:text-gray-200" value={messageInput} onChange={e => setMessageInput(e.target.value)} onKeyDown={handleKeyDown} data-id="element-8191" />
                </div>
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors" onClick={() => setShowEmojiPicker(!showEmojiPicker)} data-id="element-8192">
                  <Smile size={18} className="text-gray-500 dark:text-gray-400" data-id="element-8193" />
                </button>
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-600 to-purple-600 disabled:opacity-50 text-white" disabled={!messageInput.trim()} onClick={handleSendMessage} data-id="element-8194">
                  <Send size={18} data-id="element-8195" />
                </button>
                {/* ShapeShift Button */}
                <button onClick={() => {
                // Open ShapeShift modal with playroom integration
                const event = new CustomEvent('openShapeShiftModal', {
                  detail: {
                    inPlayroom: true,
                    angelId: currentAngelId,
                    angelName: currentAngelName
                  }
                });
                document.dispatchEvent(event);
              }} className="flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-r from-purple-500 to-cyan-500 text-white hover:shadow-md hover:shadow-purple-500/20 transition-all" title="ShapeShift" data-id="element-8196">
                  <RefreshCw size={16} data-id="element-8197" />
                </button>
              </div>
              {/* Emoji Picker */}
              {showEmojiPicker && <div className="mt-2 p-2 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-lg" data-id="element-8198">
                  <div className="grid grid-cols-8 gap-1" data-id="element-8199">
                    {['😊', '😍', '😘', '🔥', '❤️', '💋', '👅', '😈', '🍑', '💦', '👀', '🙏', '🥵', '💯', '🤤', '😏'].map((emoji, i) => <button key={i} className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-600 rounded" onClick={() => {
                  setMessageInput(prev => prev + emoji);
                  setShowEmojiPicker(false);
                }} data-id="element-8200">
                        {emoji}
                      </button>)}
                  </div>
                </div>}
              {/* ShapeShift Banner */}
              {isShapeShiftActive && <div className="mt-2 w-full px-4 py-2 bg-gradient-to-r from-purple-600/20 to-cyan-600/20 border border-purple-500/30 rounded-lg text-white text-sm flex items-center justify-between" data-id="element-8201">
                  <div className="flex items-center gap-2" data-id="element-8202">
                    <RefreshCw size={16} className="text-cyan-400" data-id="element-8203" />
                    <span data-id="element-8204">Now in ShapeShift Mode: {shapeShiftPreset}</span>
                  </div>
                  <button onClick={() => setIsShapeShiftActive(false)} className="text-gray-300 hover:text-white" data-id="element-8205">
                    <X size={16} data-id="element-8206" />
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
};